import React, { useLayoutEffect } from 'react';
import { UnauthenticatedLayout } from '../layout/UnauthenticatedLayout';
import { useStoreActions, useStoreState } from '../store';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { LocalizedText } from '../components/i18n/LocalizedText';
import { useParams } from 'react-router-dom';

export const EmailConfirmationLanding = () => {
  const emailVerified = useStoreState((state) => state.partner.emailVerified);
  const verifyEmailTokenRequest = useStoreActions((actions) => actions.partner.verifyEmailConfirmationToken);
  const loading = useStoreState((state) => state.loading.pageLoading);
  const { token } = useParams<{ token: string }>();
  useLayoutEffect(() => {
    if (token) {
      verifyEmailTokenRequest(token);
    }
  }, [verifyEmailTokenRequest, token]);
  const requestSuccessDisplay = () => {
    return (
      <>
        <CheckCircleOutlined
          style={{
            fontSize: '36px',
            color: 'green',
          }}
        />
        <p>
          <LocalizedText token={'account.emailVerificationSuccess'} />
        </p>
      </>
    );
  };
  const requestFailureDisplay = () => {
    return (
      <>
        <ExclamationCircleOutlined
          style={{
            fontSize: '36px',
            color: 'red',
          }}
        />
        <p>
          <LocalizedText token={'account.emailVerificationFailed'} />
        </p>
      </>
    );
  };
  return (
    <UnauthenticatedLayout bodyStyle={{ textAlign: 'center' }}>
      <>
        {emailVerified && requestSuccessDisplay()}
        {!emailVerified && !loading && requestFailureDisplay()}
      </>
    </UnauthenticatedLayout>
  );
};

export default EmailConfirmationLanding;
